module.exports = __webpack_public_path__ + "img/logo_colored_skanticket.1fb05535.png";